import { Component, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import * as _ from 'lodash';
import { Subscription } from 'rxjs';
import { getPrettySchedulerStatus, SchedulerStatus } from '../../enums/scheduler-status.enum';
import { ISchedulerSettings } from '../../interfaces/scheduler-settings.interface';
import { SchedulerSettingsService } from '../../services/scheduler-settings.service';

@Component({
    standalone: false,
    selector: 'app-scheduler-status',
    templateUrl: './scheduler-status.component.html',
    styleUrls: ['./scheduler-status.component.scss']
})
export class SchedulerStatusComponent implements OnInit, OnDestroy {
    schedulerSettings: ISchedulerSettings;
    subscriptions: Subscription[] = [];
    interval: NodeJS.Timeout;

    constructor(
        private schedulerSettingsService: SchedulerSettingsService,
        private ref: ChangeDetectorRef
    ) {
        this.subscriptions.push(this.schedulerSettingsService.schedulerSettings
            .subscribe(this.handleSchedulerSettingsChanges.bind(this)));
        this.interval = setInterval(
            () => {
                this.ref.markForCheck();
            },
            1000
        );
    }

    ngOnInit(): void { }

    get schedulerStatusSafe(): SchedulerStatus {
        return _.get(this.schedulerSettings, 'status', SchedulerStatus.NONE);
    }

    getStatusClass(): string {
        switch (this.schedulerStatusSafe) {
            case SchedulerStatus.IN_PROGRESS:
                return 'in-progress';
            case SchedulerStatus.PAUSED:
                return 'paused';
            default:
                return 'not-defined';
        }
    }

    handleSchedulerSettingsChanges(schedulerSettings: ISchedulerSettings): void {
        this.schedulerSettings = schedulerSettings;
    }

    getStatusText(): string {
        return getPrettySchedulerStatus(this.schedulerStatusSafe);
    }

    ngOnDestroy() {
        this.subscriptions.forEach(subscription => subscription.unsubscribe());
        clearInterval(this.interval);
    }
}
